import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/add-to-home-screen-apple-iphone.png'
import _imports_1 from '@/assets/img/add-to-home-screen-apple-iphone-menu.jpg'


const _hoisted_1 = { class: "faqs-container" }
const _hoisted_2 = { class: "a2hs-content" }
const _hoisted_3 = { class: "subLabel" }
const _hoisted_4 = { class: "ar-page-content default-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Um deine ALPrelax App bestmöglich genießen zu können, lade sie am besten gleich direkt auf deinen Startbildschirm. So hast du sie in Zukunft schnell griffbereit und kannst sie von dort aus starten.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Klicke dazu auf den unten markierten Button deines iPhone od. iPad Browsers:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Add to Homescreen",
    title: "Add to Homescreen"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Im Menü klicke auf \"Zum Home-Bildschirm\":", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Add to Homescreen",
    title: "Add to Homescreen"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Kurze Zeit später ist die App installiert und du kannst sie direkt über einen Klick auf das App-Symbol starten.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedHeaderTop = _resolveComponent("FixedHeaderTop")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FixedHeaderTop),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PageHeader, { defaultHeader: true }, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('header.a2hs')), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('addToHomeScreenSubline')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_Button, {
          text: _ctx.$t('button.tippRead'),
          dense: true,
          onHandleClicked: _ctx.handleCloseTipp
        }, null, 8, ["text", "onHandleClicked"])
      ])
    ])
  ]))
}